import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Loading = () => {
    return(
        <Box sx={{ display: 'flex'}} margin={{xs: 1}}>
            <Box sx={{ marginLeft: 2}} >
                <CircularProgress />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 2}} >
                <Typography>Se incarca . . .</Typography>
            </Box>
        </Box>        
    );
};
